import React, { useContext } from "react";
import { AuthTemplate } from "./ui/templates/AuthTemplate";
import { authStore } from "./features/auth/store/AuthStore";
import { OverlayLoader } from "./ui/atoms/OverlayLoader";
import { observer } from "mobx-react-lite";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { MainTemplate } from "./ui/templates/MainTemplate";

export const App = observer(() => {
  const { sessionId, user } = useContext(authStore);

  if (sessionId === null) {
    return (
      <>
        <AuthTemplate />
        <ToastContainer
          position="top-right"
          autoClose={2500}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          theme="colored"
          style={{ padding: "10px" }}
        />
      </>
    );
  }
  if (!user) {
    return <OverlayLoader />;
  }
  return (
    <>
      <MainTemplate />
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="colored"
        style={{ padding: "10px" }}
      />
    </>
  );
});

export default App;
